/* eslint-disable no-undef */
// eslint-disable-next-line no-unused-vars
import {Component, Vue, Prop} from 'vue-property-decorator'

@Component({
  filters: {
    acronym (value:string) {
      if (!value) return
      const [firstname, lastname] = value.trim().split(' ')
      if (!lastname) return firstname.slice(0, 2)
      return `${firstname[0]}${lastname[0]}`
    }
  }
})
class UserProfileWidget extends Vue {
  @Prop({ default: () => ({}), type: [Object] })
  user: any;
  @Prop({ default: () => false, type: [Boolean] })
  hasWidth: boolean;
  @Prop({default: false, type: [Boolean]})
  disable: boolean

  get avatarColor (): string {
    if (this.disable) return 'grey'
    return 'primary'
  }

  get iconColor (): string {
    if (this.disable) return 'grey'
    return 'black'
  }

  get fullname () {
    if (!Object.keys(this.user).length) return ''
    return this.user.fullname || `${this.user.firstname} ${this.user.lastname}`.trim()
  }

  get address (): any {
    return this.user.address
  }

  get roleValue() {
    return this.user.role_name
  }
}

export default UserProfileWidget



// WEBPACK FOOTER //
// ./src/components/user-profile-widget/index.ts